// Module
var code = `<div class="modal-dialog modal-lg conflictExceededDetails" id="js-conflict-exceeded-details" role="document">
    <div class="modal-content force-text-wrap-word" tabindex="-1">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <div data-bind="with: alert">
                <h3 class="modal-title" id="myModalLabel" data-bind="text: title, attr:{ class: 'modal-title ' + headerClass() }"></h3>
                <div class="notification-time" data-bind="text: displayDate().format('LLL')"></div>
            </div>
        </div>
        <div class="modal-body">
            <h3 data-bind="html: alert.message"></h3>
            <div style="position: relative; height: 300px">
                <virtual-grid style="height: 300px" class="resizable flex-window" params="controller: gridController"></virtual-grid>
            </div>
        </div>
        <div class="modal-footer" data-bind="compose: \$root.footerPartialView">
        </div>
    </div>
</div>
<div class="tooltip json-preview js-conflict-exceeded-tooltip" style="opacity: 0">
</div>
`;
// Exports
export default code;